import { defaultWriteDescription } from "./constants";
import { CsvChunkParser } from "./parser";
import { Matrix, CsvDescription, CsvWriteDescription } from "./types";

export function trim(value: string, char: string) {
	if (char === ']') char = '\\]';
	if (char === '^') char = '\\^';
	if (char === '\\') char = '\\\\';
	return value.replace(new RegExp('^[' + char + ']+|[' + char + ']+$', 'g'), '');
}

export function escapeValue(value: unknown, desc: CsvWriteDescription) {
	value = (value ?? '').toString();
	let result = desc.quote ? desc.quote : '';
	let ch: string;
	for (let i = 0; i < (value as string).length; i++) {
		ch = (value as string).charAt(i);
		switch (ch) {
			case desc.delimiter:
				result += desc.delimiterReplacement == null ? (desc.quote == null ? '' : ch) : desc.delimiterReplacement;
				break;
			case desc.quote:
				result += desc.quoteReplacement == null ? (desc.quote + desc.quote) : desc.quoteReplacement;
				break;
			case '\r':
				result += desc.crReplacement == null ? ch : desc.crReplacement;
				break;
			case '\n':
				result += desc.lfReplacement == null ? ch : desc.lfReplacement;
				break;
			default:
				result += ch;
		}
	}
	return result + (desc.quote ? desc.quote : '');
}

export function arrayToCsvLine(row: unknown[], desc: CsvWriteDescription) {
	return row.map((v: unknown) => escapeValue(v, desc)).join(desc.delimiter);
}

export function arrayToCsv(data: Matrix, desc?: Partial<CsvWriteDescription>) : string {
	const description = Object.assign({}, defaultWriteDescription, desc);
	let csv = '';
	for (let r = 0; r < data.length; r++) {
		csv += arrayToCsvLine(data[r], description) + "\n";
	}
	return csv;
}

export function csvToArray(csv: string, desc?: Partial<CsvDescription>): Matrix<string> {
	const parser = new CsvChunkParser(desc);
	const data = parser.parseChunk(csv);
	if (!parser.eol) data.push(parser.incompleteLine);
	return data;
}
